import { useEffect } from 'react';
import {
  applySignInEmailFieldError,
  clearSignInEmailFieldError,
  isValidSignInEmail,
  signInFormSelector,
} from './sign-in-email-validation-helpers';

// This should cleanup after the redisign of the ticket- LW1-28403
export const useSignInEmailValidation = () => {
  useEffect(() => {
    const form = document.querySelector<HTMLFormElement>(signInFormSelector);
    if (!form) {
      return;
    }

    const getUsernameInput = (): HTMLInputElement | null => {
      return form.querySelector<HTMLInputElement>('input[name="username"]');
    };

    const onSubmitCapture = (event: Event) => {
      if (event.target !== form) {
        return;
      }
      const data = new FormData(form);
      const raw = data.get('username');
      const value = typeof raw === 'string' ? raw : '';
      if (isValidSignInEmail(value)) {
        const input = getUsernameInput();
        if (input) {
          clearSignInEmailFieldError(input);
        }
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const input = getUsernameInput();
      if (input) {
        applySignInEmailFieldError(input);
      }
    };

    const onInput = (event: Event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) {
        return;
      }
      if (target.name !== 'username' || target.form !== form) {
        return;
      }
      clearSignInEmailFieldError(target);
    };

    const onFocusOutCapture = (event: Event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) {
        return;
      }
      if (target.name !== 'username' || target.form !== form) {
        return;
      }
      if (isValidSignInEmail(target.value)) {
        clearSignInEmailFieldError(target);
      } else {
        applySignInEmailFieldError(target);
      }
    };

    form.addEventListener('submit', onSubmitCapture, true);
    form.addEventListener('input', onInput, true);
    form.addEventListener('focusout', onFocusOutCapture, true);
    return () => {
      form.removeEventListener('submit', onSubmitCapture, true);
      form.removeEventListener('input', onInput, true);
      form.removeEventListener('focusout', onFocusOutCapture, true);
      const input = getUsernameInput();
      if (input) {
        clearSignInEmailFieldError(input);
      }
    };
  }, []);
};
